
import { Book } from '@/types/book';
import { supabase } from '@/integrations/supabase/client';

/**
 * Fetch all books using the safe catalog RPC (shows to public)
 */
export const getBooks = async (): Promise<Book[]> => {
  try {
    const { data, error } = await supabase.rpc('get_book_catalog');

    if (error) {
      console.error('Error fetching book catalog via RPC:', error);
      return [];
    }

    if (!data || !Array.isArray(data)) {
      console.error('Invalid data format returned from get_book_catalog:', data);
      return [];
    }

    // The RPC returns a safe, public shape including bundle info; cast to Book for app usage
    return data as unknown as Book[];
  } catch (err) {
    console.error('Error fetching books via RPC:', err);
    return [];
  }
};

/**
 * Return only the books with active bundle status
 */
export const getCurrentBooks = async (): Promise<Book[]> => {
  const all = await getBooks();
  return all.filter(b => b.bundle?.status === 'active');
};

/**
 * Load full book content only when needed (protected by RLS)
 */
export const loadBookContent = async (bookId: number): Promise<Book | null> => {
  try {
    const { data, error } = await supabase
      .from('books')
      .select(`
        id, title, author, description, short_description, 
        cover_image_url, file_path, price, bundle_id, bundle_price,
        created_at, updated_at, image_generator, reference_movie, image_frequency,
        character_descriptions, soundtrack, studio_intro, compiled_book
      `)
      .eq('id', bookId)
      .single();
      
    if (error) {
      console.error(`Error fetching book ${bookId}:`, error);
      return null;
    }
    
    return data as unknown as Book;
  } catch (err) {
    console.error(`Error loading book ${bookId}:`, err);
    return null;
  }
};
